import * as React from 'react';
import { Button, Input } from '../../modules';

interface IDicountFormState {
  showForm: boolean;
  voucher: string;
}

interface IDiscountFormProps {
  onVoucher?: (voucherTitle: string) => void;
}

class DiscountForm extends React.Component<IDiscountFormProps, IDicountFormState> {
  public state: IDicountFormState;
  constructor(props: IDiscountFormProps) {
    super(props);
    this.state = {
      showForm: true,
      voucher: ''
    };

    this.toggleForm = this.toggleForm.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  public toggleForm() {
    this.setState({ showForm: !this.state.showForm });
  }

  private onClick() {
    if (this.props.onVoucher) {
      this.props.onVoucher(this.state.voucher);
    }
  }

  public render() {
    return (
      <div className="discountForm">
        {!this.state.showForm ? (
          <Input type="checkbox" name="discount" label="Mám slevový kód" onChange={this.toggleForm} />
        ) : (
            <form onSubmit={e => e.preventDefault()} className="form form--discount">
              <Input
                onChange={(e: any) => this.setState({ voucher: (e.target.value || '').toUpperCase() })}
                type="text"
                value={this.state.voucher}
                placeholder="Your discount code"
                // autoFocus={true}
              />
              <Button onClick={this.onClick}>Apply</Button>
            </form>
          )}
      </div>
    );
  }
}

export default DiscountForm;



// WEBPACK FOOTER //
// ./src/modules/Form/Discount/index.tsx